export default __webpack_public_path__ + "static/media/vinho tinto.b1343dee.png";